fx.ns("common.popups", class ExtractingPictures extends shared.popups.BasePersonPopup{
    
    constructor(photo)
    {
        super(photo, fx.get("assets").personSure);
        this.contentWidth = 500;
        this.contentHeight = 160;
    }

    get photo()
    {
        return this.data;
    }


    onReady()
    {
        super.onReady();
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("J'ajoutes vos photos dans votre gallerie"), className:"title center"}), {height:30, left:0, top:20, width:"100%"});
        
        let hbox = new fx.components.Box();
        hbox.addChild(new fx.components.Image(fx.assets.loader), {width : 50, height : 50, left : "center", top : "center"});
        this.addChild(hbox, {width : "100%", height : "60"});
    }

});